export function Null() {
	return null;
}
